import useAxios from 'axios-hooks'

export const useMemberMap = () => {
  const [{ data, loading, error }, getMemberMap] = useAxios({
    url: 'member-map',
  })

  return { data, loading, error, getMemberMap }
}
